import DesignTokens from '@tableau/design-tokens';
import { ColorService } from '@tableau/vizportalclient-common-components';
import { TabStyles } from '@tableau/widgets';
import { NestedCSSProperties } from 'typestyle/lib/types';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { applyColor } from '~src/style/ColorService';

import { backgroundImageUrl } from '../../commonInfra/utils/ImgUrl';
import { cssClass } from '../../style';


const CSS_PREFIX = 'WelcomeChannel';
const COLOR_OFF_WHITE = CommonStyles.Colors.Grey51;
const LINK_DEFAULT = '#5C5C5C';
const LINK_HIGHLIGHT = '#444';
export namespace WelcomeChannelStyles {

  export const getRoot = () => ColorService.instance.cssClassWithThemeOverrides(CSS_PREFIX, 'root', {
    position: 'relative',
    padding: '0 36px 26px',
    backgroundImage: `${backgroundImageUrl('home_welcome_screen_main.png')}, ${backgroundImageUrl('home_welcome_screen_bottom_color.png')}`,
    backgroundPosition: 'bottom right, bottom left',
    backgroundSize: 'auto 220px',
    backgroundRepeat: 'no-repeat, repeat-x',
  }, [
    {
      theme: 'tds-dark',
      styles: {
        backgroundImage: `${backgroundImageUrl('home_welcome_screen_main_dark.svg')}, ${backgroundImageUrl('home_welcome_screen_bottom_color_dark.svg')}`,
        backgroundSize: 'auto 160px, auto 220px',
        backgroundPosition: 'top 40px right 10px, bottom left',
        paddingTop: 20
      }
    }
  ]);

  export const footer = cssClass(CSS_PREFIX, 'footer', {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.subtle, CommonStyles.Colors.Grey245),
    padding: '6px 34px',
    color: applyColor(DesignTokens.color.font.default.secondary, CommonStyles.Colors.Grey102),
    fontSize: TabStyles.Typography.Sizing.Default,
    marginTop: '2px',
    outlineStyle: 'none',
    position: 'relative',
    $nest: {
      'p': {
        margin: '0 2px',
        lineHeight: '20px'
      },
      'a': {
        color: applyColor(DesignTokens.color.link.inline.default.default, LINK_DEFAULT),
        fontWeight: 'bold',
        $nest: {
          '&:hover': {
            color: applyColor(DesignTokens.color.link.inline.default.hover, LINK_HIGHLIGHT),
          }
        }
      }
    }
  });

  export const editModeOutline = cssClass(CSS_PREFIX, 'editModeOutline', {
    outline: '1px dashed',
  });

  const sharedCloseButtonFooter: NestedCSSProperties = {
    position: 'absolute',
    top: 5,
    right: 5,
    background: 'none',
    lineHeight: 0,  // Default line height added extra height
  };

  export const closeButtonContainer = cssClass(CSS_PREFIX, 'close_button_container', {
    ...sharedCloseButtonFooter,
    top: 5,
    right: 5
  });

  export const closeButtonFooterContainer = cssClass(CSS_PREFIX, 'close_button_footer_container', {
    ...sharedCloseButtonFooter,
    top: 1,
    right: 5
  });

  export const CloseButtonStyleName = cssClass(CSS_PREFIX, 'close_button', {
    alignItems: 'center',
    display: 'inline-flex',
    justifyContent: 'center',
    $nest: {
      '&&': { minHeight: 30, minWidth: 30, height: 30, width: 30, padding: 0 },
    }
  });

  export const header = cssClass(CSS_PREFIX, 'header', {
    fontSize: 28,
    fontWeight: 'normal',
    color: applyColor(DesignTokens.color.font.default.default, COLOR_OFF_WHITE),
    marginTop: 12,
    marginBottom: 10,
    lineHeight: 1.3,
  });

  export const subheader = cssClass(CSS_PREFIX, 'subheader', {
    fontSize: 14,
    fontWeight: 'normal',
    lineHeight: '21px',
    color: applyColor(DesignTokens.color.font.default.default, COLOR_OFF_WHITE),
    marginTop: 14,
    marginBottom: 26,
  });

  export const links = cssClass(CSS_PREFIX, 'links', {
    marginTop: 26,
    marginBottom: 0,
    fontWeight: 'lighter',
  });

  export const link = cssClass(CSS_PREFIX, 'link', {
    background: 'none',
    border: '1px solid transparent',
    fontWeight: 'bold',
    color: applyColor(DesignTokens.color.link.standalone.default.default, LINK_DEFAULT),
    margin: 0,
    padding: 0,
    fontSize: TabStyles.Typography.Sizing.Default,
    $nest: {
      '&:hover': {
        color: applyColor(DesignTokens.color.link.standalone.default.hover, LINK_HIGHLIGHT),
        textDecoration: 'underline'
      },
      '&:focus': {
        color: applyColor(DesignTokens.color.link.standalone.default.active, '#2e2e2e'),
        border: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.dark, LINK_HIGHLIGHT),
        boxShadow: '0 0 4px 0 ' + applyColor(DesignTokens.color.font.default.default, LINK_HIGHLIGHT),
        textDecoration: 'underline',
        outline: 'none' // Remove default focus
      }
    }
  });

  export const linkDivider = cssClass(CSS_PREFIX, 'link-divider', {
    padding: '0 5px',
    color: applyColor(DesignTokens.color.font.default.subtle, '#bfbfbf')
  });
}
